import axios from 'axios';

export const dataUrlToBlob = async (dataUrl) => {
  const response = await axios.get(dataUrl, { responseType: 'blob' });
  return response.data;
};
